import { UserSearch, UserSearchReadModel } from './user-search';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserialize } from 'santee-dcts';
import { Observable, of } from 'rxjs';

import { Settings } from '../../core';
import { User } from '../../user';

@Injectable()
export class UsersStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public getSpecificUser(userPk: number): Observable<User> {
        return this.http.get(`${this.settings.apiUrl}/admin/users?editedUserPk=${userPk}`)
            .pipe(
                map((response) => deserialize(response, User)),
            ) as Observable<User>;
    }

    public search(searchTerm: string): Observable<UserSearch[]> {
        return searchTerm
            ? this.http.get(`${this.settings.apiUrl}/admin/users/search`, { params: { searchTerm } })
                .pipe(map(users => deserialize(users, UserSearchReadModel).users))
            : of([]);
    }
}